import { AUDIT_BASE_URL } from "../../utils/ApiUrls";

class AuditManagerDashboardService {
  /**
   * Get dashboard statistics for Audit Manager
   * @param {string} accessToken - JWT access token
   */
  async getDashboardStats(accessToken) {
    try {
      const response = await fetch(`${AUDIT_BASE_URL}/dashboard/audit-manager/stats/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Failed to fetch dashboard statistics',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  /**
   * Get recent audits for Audit Manager dashboard
   * @param {string} accessToken - JWT access token
   */
  async getRecentAudits(accessToken) {
    try {
      const response = await fetch(`${AUDIT_BASE_URL}/dashboard/audit-manager/recent-audits/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Failed to fetch recent audits',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }
  /**
   * Get recent recommendations for Audit Manager dashboard
   * @param {string} accessToken - JWT access token
   */
  async getRecentRecommendations(accessToken) {
    try {
      const response = await fetch(`${AUDIT_BASE_URL}/dashboard/audit-manager/recent-recommendations/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Failed to fetch recent recommendations',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }
}

const auditManagerDashboardService = new AuditManagerDashboardService();
export default auditManagerDashboardService;